import {
    Button,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from "@mui/material";
import axios from "../../../utils/axiosInstance";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {
    MILLIS_TO_LOCALE,
    MILLIS_TO_LOCALE_DIGIT_FORMAT,
} from "../../../utilities/helpers/formatUnix";
import { PAGE_TEMPLATE } from "../LandingPage/constants";
import RefreshIcon from "@mui/icons-material/RefreshRounded";

const ChangeLogTable = () => {
    // hooks
    const [loader, setLoader] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [logsList, setLogsList] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [skipKey, setSkipKey] = useState("");

    const [skipKeyQueue, setskipKeyQueue] = useState<any>("");

    useEffect(() => {
        getChangeLogs();
    }, []);

    const resetTableMeta = () => {
        setskipKeyQueue([]);
        setPage(0);
    };

    const getChangeLogs = async () => {
        resetTableMeta();
        const pages = await getPagesLogs(rowsPerPage);
        setTotalCount(pages.totalCount);
        setLogsList([...pages.list]);
    };

    const getPagesLogs = async (
        limit: number | string = rowsPerPage || 0,
        skip: string = skipKey || "",
        skipQueue: any[] | null = skipKeyQueue
    ) => {
        const pages = await getPageLogsAPI(limit, skip);
        const list = pages?.list;
        list.length && pushKey(list[list.length - 1]?.lastModified, skipQueue);
        return pages;
    };

    const getPageLogsAPI = async (
        limit: number | string,
        skip: string = ""
    ) => {
        try {
            setLoader(true);
            const saveVersion = await axios.get(
                `${process.env.BASE_URL}api/v1/cms/page/changelogs?skip=${skip}&limit=${limit}`
            );
            return saveVersion.data?.data;
        } catch (error: any) {
            console.log("Error in getting master information", error.response);
            enqueueSnackbar(error.response?.data?.message, {
                variant: "warning",
            });
        } finally {
            setLoader(false);
        }
    };

    const tableRowRender = () => {
        return (
            <TableRow>
                <TableCell width={200}>
                    <h3>Event</h3>
                </TableCell>
                <TableCell width={100}>
                    <h3>Page</h3>
                </TableCell>
                <TableCell width={100}>
                    <h3>Date</h3>
                </TableCell>
                <TableCell width={100}>
                    <h3>Editor</h3>
                </TableCell>
            </TableRow>
        );
    };

    const handleChangePage = async (event: unknown, newPage: number) => {
        let skipKeyValue = "";
        let queue;
        if (newPage < page) {
            queue = popTwice();
            setskipKeyQueue([...queue]);
            skipKeyValue = queue[queue.length - 1] || "";
            console.log(skipKeyQueue);
        } else {
            skipKeyValue = skipKeyQueue[skipKeyQueue.length - 1];
        }
        setPage(newPage);
        const pages = await getPagesLogs(rowsPerPage, skipKeyValue, queue);
        setLogsList([...pages.list]);
        setTotalCount(pages.totalCount);
    };

    const handleChangeRowsPerPage = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setskipKeyQueue([]);
        const pages = await getPagesLogs(event.target.value, "", []);
        setLogsList([...pages.list]);
        setTotalCount(pages.totalCount);
    };

    const pushKey = (key: any, queue: any = skipKeyQueue) => {
        const skipValue = [...queue, key];
        setskipKeyQueue(skipValue);
    };

    const popKey = (queue: any[] = skipKeyQueue) => {
        const skipValue = [...queue];
        const popValue = skipValue.pop();
        setskipKeyQueue(skipValue);
        return skipValue;
    };

    const popTwice = () => {
        const queue1 = popKey();
        const queue = popKey(queue1);
        return queue;
    };

    const handleRefresh = () => {
        getChangeLogs();
    };

    return (
        <div>
            <div className="header-content-list">
                <div className="ingest-header-refresh">
                    <span className="title-change-logs">Change Logs </span>{" "}
                    <RefreshIcon onClick={handleRefresh} />
                </div>
            </div>
            {loader && <CircularProgress size={30} />}
            <div>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 500 }} aria-label="simple table">
                        <TableHead>{tableRowRender()}</TableHead>
                        <TableBody>
                            {logsList.map((row: any, index: number) => {
                                return (
                                    <TableRow
                                        key={row.id}
                                        sx={{
                                            "&:last-child td, &:last-child th":
                                                { border: 0 },
                                        }}
                                    >
                                        <TableCell>
                                            {row?.logMessage || ""}
                                        </TableCell>
                                        <TableCell>
                                            {PAGE_TEMPLATE[row?.templateType]}
                                        </TableCell>
                                        <TableCell>
                                            {MILLIS_TO_LOCALE_DIGIT_FORMAT(
                                                row?.lastModified
                                            )}
                                        </TableCell>
                                        <TableCell>{row?.editor}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};

export default ChangeLogTable;
